// extracted by mini-css-extract-plugin
module.exports = {"b1bq2cra":"b1bq2cra","f1806ge7":"f1806ge7"};